/* tslint:disable */
/* eslint-disable */
/**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AccountDebondingRequest
 */
export interface AccountDebondingRequest {
    /**
     * 
     * @type {string}
     * @memberof AccountDebondingRequest
     */
    address: string;
    /**
     * 
     * @type {number}
     * @memberof AccountDebondingRequest
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof AccountDebondingRequest
     */
    size: number;
}

export function AccountDebondingRequestFromJSON(json: any): AccountDebondingRequest {
    return AccountDebondingRequestFromJSONTyped(json, false);
}

export function AccountDebondingRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountDebondingRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'address': json['address'],
        'page': json['page'],
        'size': json['size'],
    };
}

export function AccountDebondingRequestToJSON(value?: AccountDebondingRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'address': value.address,
        'page': value.page,
        'size': value.size,
    };
}


